<template>
  <Card variant="outline-secondary" size="medium">
    <View gap="md" align="center">
      <slot name="leading">
        <Avatar :user-name="name" size="medium" />
      </slot>

      <View direction="column" gap="xs" :grow="1" class="identity">
        <!-- One line on a desktop; on a phone the roles take a line of their own under the name -->
        <div class="headline">
          <span class="who">
            <Text variant="label-medium">{{ name }}</Text>
            <Badge v-if="isYou" label="You" size="small" variant="ghost" />
          </span>
          <span v-if="badges?.length" class="roles">
            <Badge
              v-for="badge in badges"
              :key="badge.label"
              :label="badge.label"
              size="small"
              :variant="badge.variant"
            />
          </span>
        </div>
        <Text v-if="details" variant="body-small" color="secondary">{{ details }}</Text>
        <Text v-if="meta" variant="body-small" color="tertiary">{{ meta }}</Text>
      </View>

      <slot name="action" />
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Avatar, Badge, Card, Text, View } from '@tallo/design-system';

import { TeamRoleBadge } from './team-roles';

defineProps<{ name: string; details?: string; meta?: string; isYou?: boolean; badges?: TeamRoleBadge[] }>();
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

// A long name or email has nowhere to break, so it wraps rather than pushing the row past a phone's width
.identity {
  min-width: 0;
  overflow-wrap: anywhere;
}

.headline,
.who,
.roles {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--t-spacing-sm);
}

@include mobile {
  .headline {
    flex-direction: column;
    align-items: start;
    gap: var(--t-spacing-xs);
  }
}
</style>
